module.exports = __webpack_public_path__ + "img/cur-banner.97efb982.png";